<template>
  <a-card size="small" type="inner" title="Reconciled Payment Transaction Summary">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">

        <a-col :span="6">
          <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>

          <a class="ml-2" @click="() => this.expand = !this.expand ">
            Filter
            <a-icon :type="expand ? 'up' : 'down'"/>
          </a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="id"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }">
        <div slot="count" slot-scope="record">
          {{ number(record.count) }}
        </div>

        <div slot="bills" slot-scope="record">
          {{ number(record.total_bills) }}
        </div>

        <div slot="amount" slot-scope="record">
          {{ currency(record.price) }}
        </div>

        <div slot="adminFee" slot-scope="record">
          {{ currency(record.admin_fee) }}
        </div>

        <div slot="shareFee" slot-scope="record">
          {{ currency(record.share_fee) }}
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>

<script>
const columns = [
  {
    dataIndex: 'product_name',
    key: 'product_name',
    title: 'Product Name',
    width: 150,
  },
  {
    key: 'count',
    title: 'Count',
    scopedSlots: {customRender: 'count'}
  },
  {
    key: 'bills',
    title: 'Bills',
    scopedSlots: {customRender: 'bills'}
  },
  {
    key: 'amount',
    title: 'Amount',
    scopedSlots: {customRender: 'amount'}
  }, {
    key: 'admin_fee',
    title: 'Admin Fee',
    scopedSlots: {customRender: 'adminFee'}
  }, {
    key: 'share_fee',
    title: 'Fee',
    scopedSlots: {customRender: 'shareFee'}
  }
];

export default {
  name: "report-product-transaction-summary",
  computed: {
    uri() {
      return this.routeUri('report.transaction.summary.product')
    },
    filteredRanges: {
      get() {
        return this.filters.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
      },
      set(val) {
        this.filters.date = val.map((moment) => moment.format('YYYY-MM-DD'))
      }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      items: {},
      loading: false,
      expand: false,
      filters: {
        date: [],
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        date: []
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.uri, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
  }
}
</script>

<style scoped>

</style>
